import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const PRCV = () => {
    const accordionContent = [
        <div key="1" className="p-4">
            <p>Induction Algorithms. Rule Induction. Decision Trees. Bayesian Methods. The Basic Naıve Bayes Classifier.
                Naive Bayes Induction for Numeric Attributes. Correction to the Probability Estimation. Laplace Correction. No
                Match. Other Bayesian Methods. Other Induction Methods. Neural Networks. Genetic Algorithms. Instance-
                based Learning. Support Vector Machines.</p>
        </div>,
        <div key="2" className="p-4">
            <p>About Statistical Pattern Recognition. Classification and regression. Features and Feature Vectors, and
                Classifiers. Pre-processing and feature extraction. The curse of dimensionality. Polynomial curve fitting. Model
                complexity. Multivariate non-linear functions. Bayes' theorem. Decision boundaries. Parametric methods.
                Sequential parameter estimation. Linear discriminant functions. Fisher's linear discriminant. Feed-forward
                network mappings.</p>
        </div>,
        <div key="3" className="p-4">
            <p>Review of image processing techniques – classical filtering operations – thresholding techniques – edge
                detection techniques – corner and interest point detection – mathematical morphology – texture.</p>
        </div>,
        <div key="4" className="p-4">
            <p>Binary shape analysis – connectedness – object labelling and counting – size filtering – distance functions –
                skeletons and thinning – deformable shape analysis – boundary tracking procedures – active contours – shape
                models and shape recognition – centroidal profiles – handling occlusion – boundary length measures –
                boundary descriptors – chain codes – Fourier descriptors – region descriptors – moments.</p>
        </div>
    ];

    const tabData = [
        {
            id: 'syllabus',
            label: 'Syllabus',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'notes',
            label: 'Notes',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'important',
            label: 'Important Questions',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'books',
            label: 'Books',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'PYQ',
            label: 'PYQ',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'youtube_playlist',
            label: 'Video Lectures',
            content: null, // Will be replaced in SubjectPage
        },
    ];

    return (
        <SubjectPage
            subjectName="Pattern Recognition and Computer Vision"
            subjectKey="PRCV"
            accordionContent={accordionContent}
            tabData={tabData}
            adminEmail="snaped4338@gmail.com"
            firestoreCollections={{
                notes: 'PRCVNotes',
                videos: 'PRCVVideos'
            }}
        />
    );
};

export default PRCV;